import { Text } from "@chakra-ui/react";

const sizes = {
    sm: { px: '10px', py: '3px', fontSize: '12px' },
    md: { px: '14px', py: '6px', fontSize: '13px' },
};

// Zielona "pigułka" z nazwą kategorii — wspólna dla kart i strony wydarzenia
const CategoryTag = ({ children, size = "md", ...rest }) => (
    <Text as="span" display="inline-block" borderRadius="full" bg="brand.100" color="brand.600"
          fontWeight={600} lineHeight="1.4" whiteSpace="nowrap" {...sizes[size]} {...rest}>
        {children}
    </Text>
);

export default CategoryTag;
